import React from "react";
import "utils/sentry";
import * as Sentry from "@sentry/react";
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import { ApolloProvider } from "@apollo/client";
import { Provider } from "react-redux";
import { client } from "helpers/apolloClientLink";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import LanguageProvider from "components/LanguageProvider/LanguageProvider";
import useGetTranslationFiles from "components/LanguageProvider/utils/getTranslationFiles";
import store from "widgets/Donation/store/store";
import { STRIPE_KEY, TURNSTILE_KEY } from "helpers/constants";
import PaymentContainer from "./paymentContainer";

// Stripe requires this promise to be created once, outside of render, and reused -
// recreating it on every render causes Elements to warn and ignore the new value.
const stripePromise = loadStripe(STRIPE_KEY);

const DonationPage = () => {
  const { translations } = useGetTranslationFiles();
  if (!window.Chuffed.donationInit) {
    return;
  }

  // Basic information necessary to retrieve data
  const campaignId = window.Chuffed && window.Chuffed.donationInit.recipient.id;
  const perkId = (window.Chuffed && window.Chuffed.donationInit?.selectedPerk?.id) || null;
  const recipientType = window.Chuffed && window.Chuffed.donationInit.recipientType;

  return (
    <Provider store={store}>
      <LanguageProvider translations={translations}>
        <ApolloProvider client={client}>
          <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog>
            <Elements stripe={stripePromise}>
              <PaymentContainer
                campaignId={campaignId}
                perkId={perkId}
                recipientType={recipientType}
                turnstileKey={TURNSTILE_KEY}
              />
            </Elements>
          </Sentry.ErrorBoundary>
        </ApolloProvider>
      </LanguageProvider>
    </Provider>
  );
};

export default DonationPage;
